"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildHouseDecorations = void 0;
var seedrandom_1 = __importDefault(require("seedrandom"));
var data_1 = require("../data");
var math_1 = require("./math");
var BuildHouseDecorations = function () {
    var data = {
        doorBlockX: 0,
        verticalWindows: [],
        horizontalWindow: [],
        woodPanel: [],
    };
    var random = (0, seedrandom_1.default)(data_1.GameData.seed);
    // const random = seedrandom(Math.random().toString());
    var width = data_1.HouseData.xBlocks;
    var height = data_1.HouseData.yBlocks;
    var glass = [];
    for (var i = 0; i < height; i++)
        glass.push(new Array(width).fill(false));
    // door position
    var doorX = Math.floor(random.quick() * width);
    glass[height - 1][doorX] = true;
    data.doorBlockX = doorX;
    //vertical windows
    for (var y = 0; y < height; y++) {
        for (var x = 0; x < width; x++) {
            if (glass[y][x] || random.quick() < 0.8) {
                continue;
            }
            var yy = y;
            for (; yy < height; yy++) {
                if (glass[yy][x] || random.quick() < 0.5)
                    break;
                glass[yy][x] = true;
            }
            var length_1 = yy - y;
            if (length_1 == 0)
                continue;
            data.verticalWindows.push({
                blockX: x,
                blockY: y,
                length: yy - y,
            });
        }
    }
    // horizontal windows
    for (var y = 0; y < height; y++) {
        for (var x = 0; x < width; x++) {
            if (glass[y][x] || random.quick() < 0.7) {
                continue;
            }
            var xx = x;
            for (; xx < width; xx++) {
                if (glass[y][xx] || random.quick() < 0.4)
                    break;
                glass[y][xx] = true;
            }
            var length_2 = xx - x;
            if (length_2 == 0)
                continue;
            data.horizontalWindow.push({
                blockX: x,
                blockY: y,
                length: xx - x,
            });
        }
    }
    // wood panels
    var woodPanelPercentage = (data_1.GameData.itemLevel.houseSize - 2) / 30; // max number of wood panels house size level 30, -5 because we start having wood panels from at least level 3
    if (woodPanelPercentage > 1)
        woodPanelPercentage = 1;
    if (woodPanelPercentage < 0)
        woodPanelPercentage = 0;
    var woodPanelsCount = Math.ceil(woodPanelPercentage * 8); // max 8 wood panels at max percentage
    for (var i = 0; i < woodPanelsCount; i++) {
        var blockX = Math.floor(random.quick() * data_1.HouseData.xBlocks);
        var blockY = Math.floor(random.quick() * data_1.HouseData.yBlocks);
        var panel = {
            blockX: blockX,
            blockY: blockY,
            width: (0, math_1.lerp)(1, Math.min(data_1.HouseData.xBlocks - blockX, Math.floor(data_1.HouseData.xBlocks * 0.5)), random.quick()),
            height: (0, math_1.lerp)(1, Math.min(data_1.HouseData.yBlocks - blockY, Math.floor(data_1.HouseData.yBlocks * 0.5)), random.quick()),
        };
        data.woodPanel.push(panel);
    }
    return data;
};
exports.BuildHouseDecorations = BuildHouseDecorations;
